

























export default

	props:
		card: Object

	computed:
		aspect: -> 380/216

		articleLink: -> "/#{@card.uri}"

